import ConversationApi from '../../api/inbox/conversation';
import { buildConversationStatsUpdate } from '../../helper/conversationStats';
import types from '../mutation-types';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  filteredAllCount: null, // Count con filtri applicati (dall'endpoint index), null = non ancora popolato
  unreadCount: 0,
  unreadCountByInbox: {},
};

export const getters = {
  getStats: ($state) => $state,
  getUnreadCountByInbox: ($state) => (inboxId) => {
    if (!inboxId) {
      return $state.unreadCount;
    }

    const count = $state.unreadCountByInbox[inboxId] || 0;
    return count;
  },
};

export const actions = {
  get: async ({ commit, rootState }, params = {}) => {
    try {
      // Se non vengono specificati parametri, usiamo quelli correnti dal router
      const currentRoute = rootState.route;
      const defaultParams = {};

      // Inbox di default dalla route se presente
      if (currentRoute && currentRoute.params && currentRoute.params.inbox_id) {
        defaultParams.inboxId = currentRoute.params.inbox_id;
      }

      // Filtri correnti dallo store conversazioni, per allineare i contatori a ciò che si vede in lista
      const storeFilters =
        (rootState.conversations &&
          rootState.conversations.conversationFilters) ||
        {};
      const fallbackStatus =
        (rootState.conversations && rootState.conversations.chatStatusFilter) ||
        undefined;

      const filtersFromStore = {
        status: storeFilters.status || fallbackStatus,
        assigneeType: storeFilters.assigneeType,
        labels: storeFilters.labels,
        label_id: storeFilters.label_id,
        label_source_id: storeFilters.label_source_id,
        conversationType: storeFilters.conversationType,
        include_labeled: storeFilters.include_labeled,
        assignee_id: storeFilters.assignee_id,
        contact_id: storeFilters.contact_id,
      };

      // Utilizziamo i parametri forniti esplicitamente (che sovrascrivono), uniti a route e filtri store
      const requestParams = {
        ...filtersFromStore,
        ...defaultParams,
        ...params,
      };

      const response = await ConversationApi.meta(requestParams);

      if (!response.data || !response.data.meta) {
        return null;
      }

      const {
        data: { meta },
      } = response;

      commit(types.UPDATE_CONVERSATION_STATS, {
        ...meta,
        inboxId: requestParams.inboxId,
      });

      return meta;
    } catch (error) {
      return null;
    }
  },
};

export const mutations = {
  [types.UPDATE_CONVERSATION_STATS]($state, meta) {
    if (!meta || typeof meta !== 'object') {
      return;
    }

    const updates = buildConversationStatsUpdate($state, meta);

    Object.entries(updates).forEach(([key, value]) => {
      $state[key] = value;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
